import DateBadge from '../../DateBadge';
import { Task } from '../../types';
import getTaskDisplay from '../../utils/getTaskDisplay';
import priorityToDateBadgeIcon from '../../utils/priorityToDateBadgeIcon';
import TaskRowShell from '../../common/TaskRowShell';

const noop = () => {};

/**
 * A completed task rendered as a persisted, non-interactive row in the group panel: the task's date
 * badge + title with a green "Completed" label and check. Active tasks use TaskRow; completed ones
 * use this so we don't fight TaskRow's active-only MemberOperator gating (which unmounts on COMPLETED).
 */
export default function CompletedTaskRow({ task }: Readonly<{ task: Task }>) {
    const { title } = getTaskDisplay(task);

    return (
        <TaskRowShell
            title={title}
            onCtaClick={noop}
            dateBadge={<DateBadge date={task.due_date} icon={priorityToDateBadgeIcon(task.priority)} />}
            completed
        />
    );
}
